import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import './style.css';
import { BitsyModal, ProductItem } from '..';

// Services
import BBAnalytics from '../../services/BBAnalytics';
import CartUtils from '../../services/CartUtils';
import Environment from '../../services/Environment';
import Auth from '../../services/Auth';

const ProductRecommendations = ({
  onCartUpdate,
  products,
  page = null,
  customTitle = '',
}) => {
  const history = useHistory();
  const [modalType, setModalType] = useState('NONE');

  const recordKlaviyoView = (product) => {
    const isPromo = true;
    const position = page;
    BBAnalytics.viewedProductEvent(product, isPromo, position);
  };

  const handleAddToCart = async (productInfo, variation) => {
    recordKlaviyoView(productInfo);
    const newState = { modalType };
    const promoItem = false;
    const res = await CartUtils.addProductToCart(
      productInfo,
      variation,
      newState,
      Environment.store,
      promoItem,
    );

    if (res) {
      setModalType(res.modalType);
    }

    onCartUpdate();
  };

  const goToCart = () => {
    if (Auth.isLoggedIn()) {
      history.push('/checkout/review');
    } else {
      history.push('/guest/checkout/review');
    }

    if (onCartUpdate) {
      onCartUpdate();
    }

    return null;
  };

  const continueShopping = () => {
    setModalType('NONE');
    if (onCartUpdate) {
      onCartUpdate();
    }
  };

  const renderModal = () => {
    if (modalType === 'CART SUCCESS') {
      return (
        <BitsyModal
          isShowingModal
          content='cartSuccess'
          onExit={() => setModalType('NONE')}
          type='bodyAndExitModalWithTwoButtons'
          onClickMainButton={() => goToCart()}
          onClickSecondaryButton={() => continueShopping()}
          data={{}}
        />
      );
    }

    return null;
  };

  const goViewProduct = (product) => {
    recordKlaviyoView(product);
    history.push(`/products/${product.urlName}`);
  };

  return (
    <>
      {renderModal()}
      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <h3 className='productRecommendationsTitle'>
            {customTitle || 'Your Personal Product Recommendations'}
          </h3>
        </Col>
      </Row>
      <Row>
        {products.map((product, index) => {
          const dictionary = JSON.parse(product.quantityDictionaryAsString);
          const { variations } = dictionary;

          let buttonText = 'Add To Cart';
          let buttonAction = () => handleAddToCart(product);
          let isButtonDisabled = false;

          if (product.isOutOfStock) {
            buttonText = 'Out of Stock';
            isButtonDisabled = true;
            buttonAction = () => {};
          } else if (
            (dictionary.colors && dictionary.colors[0] !== 'NONE') ||
            (dictionary.variations && dictionary.variations[0] !== 'NONE')
          ) {
            buttonText = 'Select Product';
            buttonAction = () => goViewProduct(product);
          }

          if (!product.showVariationsAsMultipleItems) {
            return (
              <ProductItem
                key={product.name}
                product={product}
                index={index}
                buttonAction={buttonAction}
                isButtonDisabled={isButtonDisabled}
                buttonText={buttonText}
                positionForViewEvent={page}
                isPromoForViewEvent
                productRecommendations
              />
            );
          }

          return variations.map((variation, index2) => {
            const variationQuantity = dictionary[variation].overallQuantity;
            if (variationQuantity === 0) {
              isButtonDisabled = true;
              buttonText = 'Out of Stock';
              buttonAction = () => {};
            } else if (dictionary.colors && dictionary.colors[0] !== 'NONE') {
              isButtonDisabled = false;
              buttonText = 'Select Product';
              buttonAction = () => goViewProduct(product);
            } else {
              isButtonDisabled = false;
              buttonText = 'Add To Cart';
              buttonAction = () => handleAddToCart(product, variation);
            }
            return (
              <ProductItem
                key={`${product.name}-${variation}`}
                product={product}
                buttonAction={buttonAction}
                isButtonDisabled={isButtonDisabled}
                buttonText={buttonText}
                index={index2}
                positionForViewEvent={page}
                isPromoForViewEvent
                productRecommendations
                variation={variation}
                variationQuantity={variationQuantity}
              />
            );
          });
        })}
      </Row>
    </>
  );
};

export default React.memo(ProductRecommendations);
